import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import { QUERY_CACHE_TIME } from '../../constants';

const useIndustries = () => {
  const { t } = useContext(ConfigContext);
  const storeKey = ['industries'];
  const { isLoading, data } = useQuery(storeKey, api.fetchIndustries, {
    cacheTime: QUERY_CACHE_TIME
  });

  const industries = useMemo(
    () =>
      (data?.industries || [])
        .map((industry) => ({ ...industry, slug: t(industry.slug) }))
        .sort((a, b) => (a.slug > b.slug ? 1 : -1)),
    [data?.industries, t]
  );

  const industriesOptions = useMemo(
    () => industries.map(({ id, slug, category }) => ({ value: id, label: slug, category })),
    [industries]
  );

  const mappedIndustries = useMemo(
    () => industriesOptions.reduce((prev, { value, label }) => ({ ...prev, [value]: label }), {}),
    [industriesOptions]
  );

  return { isLoading, industries, industriesOptions, mappedIndustries };
};

export default useIndustries;
